import { useState } from "react";
import styles from "./Cache.module.scss"
import { Select, Switch } from 'antd';
import { useTranslation } from "react-i18next";
 
export const Cache = () => {
    const [cacheSwitch, setCacheSwitch] = useState(false);
    const [cacheWay, setcacheWay] = useState("free");
    const [cacheTime, setcacheTime] = useState("5s");
    const { t } = useTranslation();

    const handleCacheSwitchChange = (checked: boolean) => {
        setCacheSwitch(checked)
    };

    const handleSelectWayChange = (value: string) => {
        setcacheWay(value)
    };

    const handleSelectTimeChange = (value: string) => {
        setcacheTime(value)
    };

    return (
        <div className={styles.cacheSetting} >
            <div className={styles.cacheSettingContent}>
                <div className={styles.cacheOpen}>
                    <div className={styles.cacheOpenText}>{t('cache_mode') as string}</div>
                    <Switch checked={cacheSwitch} onChange={handleCacheSwitchChange} />
                </div>
                <div className={styles.cacheDivider}/>
                <div className={styles.cacheWay}>
                    <div className={styles.cacheOpenText}>{t('cache_method') as string}</div>
                    <Select
                        defaultValue={cacheWay}
                        style={{ width: cacheWay === "free" ? 100 : 130 , borderRadius: '2px'}}
                        // classNames={styles.cacheSelect}
                        // classNames={{
                        //             root: 'custom-select-root',
                        //             popup: 'custom-select-dropdown'
                        //         }}
                        onChange={handleSelectWayChange}
                        popupMatchSelectWidth={false}
                        options={[
                            { value: 'free', label: t('idle_caching') },
                            { value: 'fixed', label: t('fixed_time_interval') },
                        ]}
                    />
                </div>
                <div 
                className={styles.cacheTime}
                style={{ gap: cacheWay === "free" ? 48 : 20}}
                >
                    <div className={styles.cacheOpenText}>{cacheWay === "free" ? String(t('idle')) : String(t('time_interval'))}</div>
                    <Select
                        defaultValue={cacheTime}
                        style={{ width: cacheWay === "free" ? 100 : 130 }}
                        onChange={handleSelectTimeChange}
                        options={[
                            { value: '5s', label: t('5_seconds') },
                            { value: '10s', label: t('10_seconds') },
                            { value: '30s', label: t('30_seconds') },
                            { value: '1min', label: t('1_minute') },
                            { value: '5min', label: t('5_minutes') },
                            { value: '10min', label: t('10_minutes') },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};